import { FC } from 'react';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import { TableProps } from './interfaces/Table';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const tableSpacingClasses = {
  tablePadding: 'p-0',
  tableGap: 'gap-sm-eighthstep',
};
const Table: FC<TableProps & { showColumnHeaders?: boolean }> = ({
  columnHeaders,
  columnWidths,
  rows,
  sortable,
  onSort,
  sortedColumn,
  isAscending,
  onClickRow,
  showColumnHeaders = true,
  rightAlignLastColumn = true,
}) => {
  if (
    columnHeaders &&
    (columnHeaders.length !== columnWidths.length ||
      columnHeaders.length !== (sortable?.length || 0))
  ) {
    console.error(
      'Mismatch between columnHeaders, columnWidths, and sortable lengths.',
    );
    return null;
  }
  return (
    <div
      className={`grid w-full
        ${tableSpacingClasses.tablePadding} 
        ${tableSpacingClasses.tableGap} 
        ${borderClassToVisualizeElementsAndSpacing}`}
    >
      {showColumnHeaders && columnHeaders && (
        <TableHeader
          columnHeaders={columnHeaders}
          columnWidths={columnWidths}
          sortable={sortable || []}
          onSort={onSort}
          sortedColumn={sortedColumn}
          isAscending={isAscending}
          rightAlignLastColumn={rightAlignLastColumn}
        />
      )}
      {rows.map((row, rowIndex) => (
        <TableRow
          key={rowIndex}
          rowIndex={rowIndex}
          cells={row.cells}
          columnWidths={columnWidths}
          onClick={onClickRow}
          navigateToUrl={row.navigateToUrl}
          rightAlignLastColumn={rightAlignLastColumn}
        />
      ))}
    </div>
  );
};
export default Table;
